const items = document.querySelectorAll('.header-padding-top');
const header = document.querySelector('.Header');
if (items && header) {
    items.forEach((item) => {
        item.style.paddingTop = header.offsetHeight + 'px';
    });
}
